export default {
  SESSION_RESUME_REQUEST: 'session_resume_req',
  START_SESSION_RESPONSE: 'start_session_resp',
  START_SESSION_REQUEST: 'start_session_req',
  START_DIALOG_REQUEST: 'start_dialog_req',
  STOP_SESSION_REQ: 'stop_session_req',
  DIALOG_MESSAGE_EVENT: 'dialog_message_event',
  HISTORY_REQUEST: 'history_req',
  DIALOG_REQUEST: 'dialog_req',
  TYPING_EVENT: 'typing_event',
  TYPING_REQ: 'typing_req',
  STATE_EVENT: 'state_event',
  ERROR_EVENT: 'error_event',
  ATTACHMENT_EVENT: 'attachment_event',
  PING_MESSAGE: 'ping',
};
